import type { ElementType } from 'react';

/**
 * Headline that surfaces word by word out of a soft blur. Pure CSS
 * (`.mc-word` in base.css), so it costs nothing after the intro and
 * reduced motion shows the text at once. Screen readers get the
 * plain sentence from an sr-only copy.
 */
export function RevealText({
  as: Tag = 'span',
  text,
  delay = 0,
  step = 60,
  className,
}: {
  as?: ElementType;
  text: string;
  delay?: number;
  step?: number;
  className?: string;
}) {
  const words = text.split(' ');
  return (
    <Tag className={className}>
      <span className="sr-only">{text}</span>
      {words.map((w, i) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: words of a fixed sentence
          key={i}
          aria-hidden="true"
          className="mc-word"
          style={{ animationDelay: `${delay + i * step}ms` }}
        >
          {w}
          {i < words.length - 1 ? ' ' : ''}
        </span>
      ))}
    </Tag>
  );
}
